/* VystaCo homepage: horizontal scrollers, tabs, hero slider. */
(function () {
  if (window.__vysHome) return;
  window.__vysHome = true;

  function initScroller(root) {
    if (root.__vys) return; root.__vys = true;
    var track = root.querySelector('[data-track]');
    var prev = root.querySelector('[data-prev]');
    var next = root.querySelector('[data-next]');
    var bar = root.querySelector('[data-progress]');
    if (!track) return;
    function update() {
      var max = track.scrollWidth - track.clientWidth;
      var over = max > 4;
      if (prev) prev.hidden = !over || track.scrollLeft <= 4;
      if (next) next.hidden = !over || track.scrollLeft >= max - 4;
      if (bar) {
        var vis = track.clientWidth / track.scrollWidth;
        bar.parentNode.hidden = !over;
        bar.style.width = (vis * 100) + '%';
        bar.style.transform = 'translateX(' + (max > 0 ? (track.scrollLeft / max) * ((1 - vis) / vis) * 100 : 0) + '%)';
      }
    }
    function go(dir) { track.scrollBy({ left: dir * track.clientWidth * 0.85, behavior: 'smooth' }); }
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
    root.__vysUpdate = update;
  }

  function initTabs(root) {
    if (root.__vys) return; root.__vys = true;
    var tabs = root.querySelectorAll('[role="tab"]');
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { select(i); });
      tab.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          var n = (i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
          select(n); tabs[n].focus();
        }
      });
    });
    function select(n) {
      tabs.forEach(function (t, i) {
        var on = i === n;
        t.setAttribute('aria-selected', on);
        t.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) {
          panel.hidden = !on;
          if (on) { var sc = panel.querySelector('[data-vys-scroller]'); if (sc && sc.__vysUpdate) sc.__vysUpdate(); }
        }
      });
    }
  }

  function initSlider(root) {
    if (root.__vys) return; root.__vys = true;
    var track = root.querySelector('[data-track]');
    var slides = root.querySelectorAll('[data-slide]');
    var dots = root.querySelector('[data-dots]');
    var pause = root.querySelector('[data-pause]');
    if (!track || slides.length < 2) { if (dots) dots.hidden = true; return; }
    var cur = 0, timer = null, paused = false;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var interval = (parseInt(root.getAttribute('data-interval'), 10) || 6) * 1000;
    var btns = [];
    slides.forEach(function (s, i) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'vys-dot';
      b.setAttribute('aria-label', 'Show slide ' + (i + 1) + ' of ' + slides.length);
      b.addEventListener('click', function () { go(i); restart(); });
      dots.appendChild(b); btns.push(b);
    });
    function mark() { btns.forEach(function (b, i) { b.setAttribute('aria-current', i === cur); }); }
    function go(i) { cur = (i + slides.length) % slides.length; track.scrollTo({ left: slides[cur].offsetLeft, behavior: 'smooth' }); mark(); }
    track.addEventListener('scroll', function () {
      var i = Math.round(track.scrollLeft / track.clientWidth);
      if (i !== cur && i < slides.length) { cur = i; mark(); }
    }, { passive: true });
    function restart() { clearInterval(timer); if (!paused && !reduce) timer = setInterval(function () { go(cur + 1); }, interval); }
    if (pause) {
      if (reduce) { pause.hidden = true; }
      pause.addEventListener('click', function () {
        paused = !paused;
        pause.setAttribute('aria-pressed', paused);
        pause.setAttribute('aria-label', paused ? 'Play slideshow' : 'Pause slideshow');
        restart();
      });
    }
    root.addEventListener('mouseenter', function () { clearInterval(timer); });
    root.addEventListener('mouseleave', restart);
    root.addEventListener('focusin', function () { clearInterval(timer); });
    mark(); restart();
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-vys-scroller]').forEach(initScroller);
    (scope || document).querySelectorAll('[data-vys-tabs]').forEach(initTabs);
    (scope || document).querySelectorAll('[data-vys-slider]').forEach(initSlider);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
